export const streamConstants = {
  RESET_STREAM: 'RESET_STREAM',
  RESET_STREAM_OFFER: 'RESET_STREAM_OFFER',

  ADD_STREAM_SUCCESS: 'ADD_STREAM_SUCCESS',
  ADD_STREAM_FAILURE: 'ADD_STREAM_FAILURE',

  SET_STREAMS_SUCCESS: 'SET_STREAMS_SUCCESS',
  SET_STREAMS_FAILURE: 'SET_STREAMS_FAILURE',

  SET_STREAM_SUCCESS: 'SET_STREAM_SUCCESS',
  SET_STREAM_FAILURE: 'SET_STREAM_FAILURE',

  EDIT_STREAM_SUCCESS: 'EDIT_STREAM_SUCCESS',
  EDIT_STREAM_FAILURE: 'EDIT_STREAM_FAILURE',

  REMOVE_STREAM_SUCCESS: 'REMOVE_STREAM_SUCCESS',
  REMOVE_STREAM_FAILURE: 'REMOVE_STREAM_FAILURE',

  SET_STREAM_SETTINGS_SUCCESS: 'SET_STREAM_SETTINGS_SUCCESS',
  SET_STREAM_SETTINGS_FAILURE: 'SET_STREAM_SETTINGS_FAILURE',

  SET_STREAM_OFFER_REQUEST: 'SET_STREAM_OFFER_REQUEST',
  SET_STREAM_OFFER_SUCCESS: 'SET_STREAM_OFFER_SUCCESS',
  SET_STREAM_OFFER_FAILURE: 'SET_STREAM_OFFER_FAILURE',

  SET_GLOBAL_POSTBACK_SUCCESS: 'SET_GLOBAL_POSTBACK_SUCCESS',
  SET_GLOBAL_POSTBACK_FAILURE: 'SET_GLOBAL_POSTBACK_FAILURE',

  EDIT_GLOBAL_POSTBACK_SUCCESS: 'EDIT_GLOBAL_POSTBACK_SUCCESS',
  EDIT_GLOBAL_POSTBACK_FAILURE: 'EDIT_GLOBAL_POSTBACK_FAILURE',

  RESET_STREAMS_FILTER: 'RESET_STREAMS_FILTER',
  SET_STREAMS_FILTER: 'SET_STREAMS_FILTER',

  COPY_STREAM_FAILURE: 'COPY_STREAM_FAILURE',

  SET_STREAM_LANDING_SETTINGS_SUCCESS: 'SET_STREAM_LANDING_SETTINGS_SUCCESS',
  SET_STREAM_LANDING_SETTINGS_FAILURE: 'SET_STREAM_LANDING_SETTINGS_FAILURE',
};
